import { render, staticRenderFns } from "./InviteTip.vue?vue&type=template&id=1e17aa33&scoped=true&"
import script from "./InviteTip.vue?vue&type=script&lang=js&"
export * from "./InviteTip.vue?vue&type=script&lang=js&"
import style0 from "./InviteTip.vue?vue&type=style&index=0&id=1e17aa33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e17aa33",
  null
  
)

export default component.exports